import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class TipoClienteService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    obtenerTodos(callback) {
        this.gqlclient.query({
            query: gql `
        {
          tipo_cliente {
            obtenerTodos {
              respuesta {
                registros {
                  codigo
                  descripcion
                }
              }
            }
          }
        }
        `,
            variables: {},
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.tipo_cliente.obtenerTodos;
            callback({ mensajes, respuesta });
        });
    }
    obtenerTodosYSinTipoCliente(callback) {
        this.gqlclient.query({
            query: gql `
        {
          tipo_cliente {
            obtenerTodosYSinTipoCliente {
              respuesta {
                registros {
                  codigo
                  descripcion
                  idcanal
                }
              }
            }
          }
        }
        `,
            variables: {},
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.tipo_cliente.obtenerTodosYSinTipoCliente;
            callback({ mensajes, respuesta });
        });
    }
}
TipoClienteService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TipoClienteService_Factory() { return new TipoClienteService(i0.ɵɵinject(i1.GraphQLClient)); }, token: TipoClienteService, providedIn: "root" });
